/**
 * @fileoverview Custom hook for querying PointClickCare residents.
 */

import {useQuery} from "react-query";
import {
  FindResidentsUsingGETQueryParams,
  handlePccRequestLimitReached,
  PccService,
} from "../../services/PccService";

/**
 * Custom hook for finding residents in PointClickCare.
 * Returns the first resident from the search results.
 *
 * @param {FindResidentsUsingGETQueryParams} params Search parameters for finding residents.
 * @param {Object} options Query options.
 * @param {boolean} options.enabled Whether the query should be enabled.
 * @returns {Object} React Query result containing the found resident.
 */
export const useFindResidentQuery = (
  params: FindResidentsUsingGETQueryParams,
  {enabled}: {enabled: boolean},
) =>
  useQuery(
    ["findResident", params],
    async ({queryKey: [_, params]}) => {
      const {data = []} = await PccService.findResidents(
        params as FindResidentsUsingGETQueryParams,
      );

      const [resident = null] = data;

      return resident;
    },
    {
      onError: error => {
        handlePccRequestLimitReached(error);
      },
      enabled,
    },
  );
